<template>
  <div class="custom-slide-container">
  </div>
</template>

<script>
export default {
  name: 'CustomSlide',
  mounted () {
    // WHEN SWITCHING TO A RANDOM SLIDE TO A CUSTOM SLIDE
    setTimeout(() => {
      this.$el.append(this.$store.state.customImages[this.$store.getters.activeSlide.slide.image_url])
    }, 100)
  },
  watch: {
    // WHEN SWITCHING FROM A CUSTOM SLIDE TO AN OTHER
    '$store.getters.activeSlide.slide.image_url' (newValue, oldValue) {
      this.$store.commit('SHOW_PRELOADER')
      setTimeout(() => {
        if (typeof this.$el === 'object') {
          this.$el.querySelector('img').remove()
          // this.$el.replaceChild(this.$store.state.customImages[newValue], this.$store.state.customImages[oldValue])
          this.$el.append(this.$store.state.customImages[newValue])
        }
        this.$store.commit('SHOW_PRELOADER', false)
      }, 600)
    }
  }
}
</script>

<style scoped>
  .custom-slide-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(-100%);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomSlide.vue